import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";

export function DurationChallengePieChart({ data }) {
  const durationData = [
    {
      label: `One Time (${data?.durationCount?.is_ontime})`,
      value: data?.duration?.is_ontime?.toFixed(2) ?? 0,
    },
    {
      label: `30 Days  (${data?.durationCount?.thirtyDays})`,
      value: data?.duration?.thirtyDays?.toFixed(2) ?? 0,
    },
    {
      label: `60 Days  (${data?.durationCount?.sixtyDays})`,
      value: data?.duration?.sixtyDays?.toFixed(2) ?? 0,
    },
    {
      label: `90 Days  (${data?.durationCount?.ninetyDays})`,
      value: data?.duration?.ninetyDays?.toFixed(2) ?? 0,
    },
  ];

  const valueFormatter = (item) => `${item.value}%`;

  return (
    <PieChart
      series={[
        {
          data: durationData,
          highlightScope: { fade: "global", highlight: "item" },
          faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
          valueFormatter,
        },
      ]}
      height={200}
    />
  );
}

export function CategoryChallengePieChart({ data }) {
  const categories = [
    {
      label: `Mind (${data?.cateogoriesCount?.mind})`,
      value: data?.cateogories?.mind?.toFixed(2) ?? 10,
    },
    {
      label: `Body (${data?.cateogoriesCount?.body})`,
      value: data?.cateogories?.body?.toFixed(2) ?? 10,
    },
    {
      label: `Sprit (${data?.cateogoriesCount?.spirit})`,
      value: data?.cateogories?.spirit?.toFixed(2) ?? 10,
    },
    {
      label: `Seasonal (${data?.cateogoriesCount?.seasonal})`,
      value: data?.cateogories?.seasonal?.toFixed(2) ?? 10,
    },
  ];

  const valueFormatter = (item) => `${item.value}%`;
  return (
    <PieChart
      series={[
        {
          data: categories,
          highlightScope: { fade: "global", highlight: "item" },
          faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
          valueFormatter,
        },
      ]}
      height={200}
    />
  );
}

export function EmotionChallengePieChart({ data }) {
  const emotion_checkins = [
    {
      label: `Mind (${data?.emotionCheckinsCount?.mind})`,
      value: data?.emotionCheckins?.mind?.toFixed(2) ?? 0,
    },
    {
      label: `Body (${data?.emotionCheckinsCount?.body})`,
      value: data?.emotionCheckins?.body?.toFixed(2) ?? 0,
    },
    {
      label: `Sprit (${data?.emotionCheckinsCount?.spirit})`,
      value: data?.emotionCheckins?.spirit?.toFixed(2) ?? 0,
    },
    {
      label: `Seasonal (${data?.emotionCheckinsCount?.seasonal})`,
      value: data?.emotionCheckins?.seasonal?.toFixed(2) ?? 0,
    },
  ];

  const valueFormatter = (item) => `${item.value}%`;
  return (
    <PieChart
      series={[
        {
          data: emotion_checkins,
          highlightScope: { fade: "global", highlight: "item" },
          faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
          valueFormatter,
        },
      ]}
      height={200}
    />
  );
}

export default DurationChallengePieChart;
